const _isEmpty = v =>
  v === null ||
  v === undefined ||
  (v.hasOwnProperty("length") && v.length === 0) ||
  (v.constructor === Object && Object.keys(v).length === 0);

const _isExist = v => !_isEmpty(v);

export const isNumeric = num => !isNaN(num);

/**
 * Is empty?
 * @param  {array}   ...x
 * @return {boolean}
 */
export const isEmpty = (...x) => x.every(_isEmpty);

/**
 * Is exist?
 * @param  {array}   ...x
 * @return {boolean}
 */
export const isExist = (...x) => x.every(_isExist);

/**
 * Is isMobileWebView?
 * @param  {ua} browser/webivew user agent string
 * @return {boolean}
 */
export const isMobileWebView = ua => {
  const iOSRegex = RegExp("(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)", "g");
  const androidWebViewRegex = RegExp("Version/.+(Chrome)/(\\d+)\\.(\\d+)\\.(\\d+)\\.(\\d+)", "g");
  return iOSRegex.test(ua) || androidWebViewRegex.test(ua);
};

export const isMobileDevice = ua => {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
};

export const isSafari = ua => {
  return /^((?!CriOS).)*Safari/g.test(ua);
};
export const isHarmonyOS = ua => {
  return /HarmonyOS/i.test(ua);
};

export const isEmailValid = value => {
  if (!value) {
    return false;
  } else {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);
  }
};
export const getCookieValue = cookieName => {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [name, value] = cookies[i].split("=");
    if (name === cookieName) {
      return value;
    }
  }
  return null; // Return null if cookie not found
};

export const isMobileBrowser = () => {
  const userAgentCheck = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const screenWidthCheck = window.matchMedia("(max-width: 768px)").matches;
  const touchCheck = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  return userAgentCheck || (screenWidthCheck && touchCheck);
};

export const isNewsletterPDF = fileName => {
  return (
    typeof fileName === "string" &&
    fileName
      .trim()
      .toLowerCase()
      .endsWith(".pdf")
  );
};



// WEBPACK FOOTER //
// ./utils/is.js